import { SvgIcon } from '@material-ui/core'

export default function AlertIcon(props: any) {
    return (
        <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.73089 3.99268C10.8229 2.39501 13.1797 2.39502 14.2716 3.99268L14.7036 4.62463C17.4096 8.58385 19.7346 12.7905 21.6473 17.1881L21.7375 17.3956C22.4116 18.9453 21.3932 20.705 19.7136 20.8927C14.588 21.4656 9.41451 21.4656 4.28888 20.8927C2.60933 20.705 1.59097 18.9453 2.26502 17.3956L2.35524 17.1881C4.26797 12.7905 6.59293 8.58384 9.29897 4.62463L9.73089 3.99268ZM13.0013 9.00005C13.0013 9.55233 12.5536 10 12.0013 10C11.449 10 11.0013 9.55233 11.0013 9.00005C11.0013 8.44776 11.449 8.00005 12.0013 8.00005C12.5536 8.00005 13.0013 8.44776 13.0013 9.00005ZM12.0013 11.75C12.4155 11.75 12.7513 12.0858 12.7513 12.5V17.5C12.7513 17.9143 12.4155 18.25 12.0013 18.25C11.5871 18.25 11.2513 17.9143 11.2513 17.5V12.5C11.2513 12.0858 11.5871 11.75 12.0013 11.75Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
